import { render } from "./ReferralEngagementInformation.vue?vue&type=template&id=72138e06&scoped=true"
import script from "./ReferralEngagementInformation.vue?vue&type=script&lang=js"
export * from "./ReferralEngagementInformation.vue?vue&type=script&lang=js"

import "./ReferralEngagementInformation.vue?vue&type=style&index=0&id=72138e06&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72138e06"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QBanner,QExpansionItem});
